<template>
  <div>
    <div class="columns">
      <div class="map">
        <gmap-map
          :center="centerReseaux"
          :zoom="zoomCartoReseaux"
          :options="mapOptions"
          class="googleMap"
          ref="map"
          @zoom_changed="updateZoom($event)"
          @dragend="updateMarkerVisible()"
          @click="close()">

          <app-info-window-map-faces
            v-bind:centre="center"
            v-bind:marker="selectedMarkerFacesDeReseaux"
            @closeInfoWindow="selectedMarkerFacesDeReseaux=''"/>

          <gmap-marker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :clickable="m.clickable"
            :draggable="false"
            :icon="m.icon"
            @click="center=m.position, updateSelectedMarker(m)">
          </gmap-marker>

          <gmap-marker
            v-for="(point, i) in getPointsAddress"
            :key="i+point.libelle"
            :position="point.coordonnees"
            :clickable="point.clickable"
            :draggable="false"
            :icon="point.icon"
            @click="center=point.coordonnees, updateSelectedMarkerReseaux(point),
              isComponentDetailReseauxTempo = true">
          </gmap-marker>

          <gmap-marker
            key="test"
            :position="getCenterReseaux"
            :clickable="false"
            :zIndex="zIndexCenter"
            :draggable="false"
            :icon=puceNoire>
          </gmap-marker>

        </gmap-map>
      </div>

      <b-modal
        v-model="isComponentDetailReseauxTempo"
        has-modal-card
        class="modal">

        <app-info-window-map-reseaux
          :centre="center"
          :marker="selectedMarkerReseaux"
          :nbFacesRestantes="nbFacesRestantes"
          :dataProposition="dataProposition"
          @zoomReseau="zoomReseau(selectedMarkerReseaux, 0)"/>

      </b-modal>

      <b-modal
        v-model="isComponentDetailFacesReseauxTempo"
        has-modal-card
        class="modal">
        <app-info-window-map-faces :centre="center" :marker="selectedMarkerFacesDeReseaux"/>
      </b-modal>

    </div>
    <app-statistiques-geo-marketing
      :address="getCenterReseaux"
      :isochrone="isochrone"
      :typeLayerGeoMarketing="typeLayerGeoMarketing" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { setTimeout } from 'timers';
import * as types from '@/store/creationOpportunite/venteReseauxNumerique-mutation-type';
import { getMapGeoJson } from '@/api/asterop';
import { getConcurrents, overrideStyle } from '@/services/asterop/mapHelper';
import statistiquesGeoMarketing from '@/components/general/statistiquesGeoMarketing';
import { MINIMUM_CLUSTER_SIZE, TYPE_LAYER_EMPTY, MARKER_POINT_NOIR,
  TYPE_LAYER_GEO_MARKETING_CONCU, STYLE_MAPS_POI_HIDDEN,
  MAP_TYPE_CONTROL_OPTIONS, MAP_TYPE_NAME } from '@/configuration/carteConf';
import InfoWindowMapFaces from '@/components/creationOpportunite/cartographie/infoWindowMapFaces';
import InfoWindowMapReseaux from './cartographie/infoWindowMapReseaux';

const VenteReseauxNumerique = createNamespacedHelpers('venteReseauxNumerique');
const User = createNamespacedHelpers('user');
const Parametrage = createNamespacedHelpers('parametrage');

export default {
  name: 'app-map',
  data() {
    return {
      center: '',
      layerGeoMarketting: false,
      concurrents: [],
      markersFacesParReseauxVisible: [],
      minClusterSize: MINIMUM_CLUSTER_SIZE,
      nbFacesRestantes: null,
      zIndexCenter: 9999,
      dataProposition: {},
      isComponentDetailReseauxTempo: false,
      isComponentDetailFacesReseauxTempo: false,
      mapOptions: {
        mapTypeControlOptions: MAP_TYPE_CONTROL_OPTIONS,
      },
    };
  },
  watch: {
    markersFacesParReseaux() {
      this.updateMarkerVisible(true);
    },
    activeTabReseau() {
      if (this.activeTabReseau === 0 && this.zoomMarker) {
        this.zoomReseau(this.zoomMarker, 500);
      } else {
        this.zoomMarker = null;
      }
    },
    async isochrone() {
      await this.updateLayer();
    },
    async centerReseaux() {
      await this.updateLayer();
    },
    async typeLayerGeoMarketing() {
      await this.updateLayer();
    },
  },
  computed: {
    ...VenteReseauxNumerique.mapGetters({
      markersReseaux: 'markersReseaux',
      markersFacesParReseaux: 'markersFacesParReseaux',
      getZoomCartoReseaux: 'zoomCartoReseaux',
      getCenterReseaux: 'centerReseaux',
      isochrone: 'isochrone',
      typeLayerGeoMarketing: 'typeLayerGeoMarketing',
      getSelectedMarkerFacesDeReseaux: 'selectedMarkerFacesDeReseaux',
      getSelectedMarkerReseaux: 'selectedMarkerReseaux',
      getZoomMarker: 'zoomMarker',
      activeTabReseau: 'activeTabReseau',
      getPointsAddress: 'pointsAddress',
    }),
    ...User.mapGetters({
      hasGeoMarketing: 'hasGeoMarketing',
    }),
    ...Parametrage.mapGetters({
      symboles: 'symboles',
    }),
    zoomCartoReseaux: {
      get() {
        return this.getZoomCartoReseaux;
      },
      set(value) {
        this.setZoomCartoReseaux(value);
      },
    },
    centerReseaux: {
      get() {
        return this.getCenterReseaux;
      },
      set(value) {
        this.setCenterReseaux(value);
      },
    },
    selectedMarkerFacesDeReseaux: {
      get() {
        return this.getSelectedMarkerFacesDeReseaux;
      },
      set(value) {
        this.setSelectedMarkerFacesDeReseaux(value);
      },
    },
    selectedMarkerReseaux: {
      get() {
        return this.getSelectedMarkerReseaux;
      },
      set(value) {
        this.setSelectedMarkerReseaux(value);
      },
    },
    zoomMarker: {
      get() {
        return this.getZoomMarker;
      },
      set(value) {
        this.setZoomMarker(value);
      },
    },
    puceNoire() {
      if (Object.prototype.hasOwnProperty.call(this.getCenterReseaux, 'urlLogo')) {
        const h = 40;
        let w = h;
        const img = new Image();
        img.src = this.getCenterReseaux.urlLogo;
        if (img.height > 0) {
          w = img.width / (img.height / h);
        }
        const icon = {
          url: this.getCenterReseaux.urlLogo,
          scaledSize: { width: w, height: h, f: 'px', b: 'px' },
        };
        return icon;
      }

      if (Object.prototype.hasOwnProperty.call(this.getCenterReseaux, 'symbole') &&
          this.symboles &&
          Object.prototype.hasOwnProperty.call(this.symboles, this.getCenterReseaux.symbole)) {
        const icon = {
          url: this.symboles[this.getCenterReseaux.symbole],
          size: { width: 50, height: 50, f: 'px', b: 'px' },
          scaledSize: { width: 50, height: 50, f: 'px', b: 'px' },
        };
        return icon;
      }
      return MARKER_POINT_NOIR;
    },
    markers() {
      if (this.zoomCartoReseaux < 12) {
        const data = this.markersReseaux;
        data.forEach(el => {
          el.typeMarker = 'reseau';
        });
        return data;
      }
      const data = this.markersFacesParReseaux;
      data.forEach(el => {
        el.typeMarker = 'face';
      });
      return data;
    },
    concurrentsFiltres() {
      if (Object.prototype.hasOwnProperty.call(this.getCenterReseaux, 'codeType')) {
        const tmp = this.concurrents.filter(c =>
          c.codeType === this.getCenterReseaux.codeType && c.icone);
        tmp.forEach((element) => {
          element.icone = {
            url: element.icone,
            size: { width: 20, height: 20, f: 'px', b: 'px' },
            scaledSize: { width: 20, height: 20, f: 'px', b: 'px' },
          };
        });
        return tmp;
      }
      this.concurrents.forEach((element) => {
        element.icone = {
          url: element.icone,
          size: { width: 20, height: 20, f: 'px', b: 'px' },
          scaledSize: { width: 20, height: 20, f: 'px', b: 'px' },
        };
      });
      return this.concurrents;
    },
  },
  methods: {
    ...VenteReseauxNumerique.mapMutations({
      setZoomCartoReseaux: types.SET_ZOOM_CARTO_RESEAUX,
      setCenterReseaux: types.SET_CENTER_RESEAUX,
      setSelectedMarkerFacesDeReseaux: types.SET_SELECTED_MARKER_FACES_DE_RESEAUX,
      setSelectedMarkerReseaux: types.SET_SELECTED_MARKER_RESEAUX,
      setZoomMarker: types.SET_ZOOM_MARKER,
    }),
    ...Parametrage.mapActions({
      actionsLoadSymboles: 'loadSymboles',
    }),
    async updateLayer() {
      // Largement inspiré de
      // https://stackoverflow.com/questions/50496101/remove-google-map-geojson-polygon
      // https://developers.google.com/maps/documentation/javascript/datalayer
      const map = await this.$refs.map.$mapPromise;
      this.concurrents = [];
      if (this.layerGeoMarketting && this.layerGeoMarketting.setMap) {
        this.layerGeoMarketting.setMap(null);
      }
      if (!this.getCenterReseaux ||
          !this.hasGeoMarketing ||
          this.typeLayerGeoMarketing === TYPE_LAYER_EMPTY) {
        return;
      }
      this.layerGeoMarketting = new google.maps.Data({
        map: map,
      });

      const response = await getMapGeoJson(this.typeLayerGeoMarketing, this.getCenterReseaux,
        this.isochrone);
      if (this.typeLayerGeoMarketing === TYPE_LAYER_GEO_MARKETING_CONCU) {
        this.concurrents = await getConcurrents(this.getCenterReseaux,
          this.isochrone, 1, this.symboles);
      }
      const geoJson = response.data;
      const styles = geoJson.style;

      this.layerGeoMarketting.addGeoJson(geoJson);
      this.layerGeoMarketting.setStyle((feature) => {
        return overrideStyle(feature, styles);
      });
    },
    updateZoom($event) {
      this.zoomCartoReseaux = $event;
      this.selectedMarkerFacesDeReseaux = '';
      this.selectedMarkerReseaux = '';
      this.updateMarkerVisible();
    },
    updateMarkerVisible(force) {
      if (this.zoomCartoReseaux < 12) {
        this.markersFacesParReseauxVisible = [];
        return;
      }
      if (force) {
        this.markersFacesParReseauxVisible = [];
      }
      const bounds = this.$refs.map.$mapObject.getBounds();
      this.markersFacesParReseaux.forEach(m => {
        if (bounds.contains(m.position) && !this.markersFacesParReseauxVisible.includes(m)) {
          this.markersFacesParReseauxVisible.push(m);
        }
        this.markersFacesParReseauxVisible.forEach((marker) => {
          if (!bounds.contains(marker.position)) {
            this.markersFacesParReseauxVisible.splice(
              this.markersFacesParReseauxVisible.indexOf(marker), 1);
          }
        });
      });
    },
    updateSelectedMarker(marker) {
      if (marker.typeMarker === 'face') {
        this.selectedMarkerFacesDeReseaux = marker;
        this.isComponentDetailFacesReseauxTempo = true;
      } else {
        this.isComponentDetailReseauxTempo = true;
        this.selectedMarkerReseaux = marker;
      }
    },
    close() {
      if (this.selectedMarkerReseaux) {
        this.selectedMarkerReseaux = '';
      }
      if (this.selectedMarkerFacesDeReseaux) {
        this.selectedMarkerFacesDeReseaux = '';
      }
    },
    zoomReseau(marker, timeout) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      new Promise(resolve => {
        this.centerReseaux = marker.position;
        setTimeout(resolve, timeout);
      }).then(() => {
        loadingComponent.close();
        this.zoomCartoReseaux = 12;
        this.updateMarkerVisible();
      });
    },
    async autoZoom() {
      if (this.$refs.map === undefined) return;
      await this.$refs.map.$mapPromise;
      this.fitBounds();
    },
    fitBounds() {
      const latlngbounds = new google.maps.LatLngBounds();
      if (this.markersFacesParReseauxVisible.length) {
        this.markersFacesParReseauxVisible.forEach(marker => {
          latlngbounds.extend(marker.position);
        });
      }
      if (this.markersReseaux.length) {
        this.markersReseaux.forEach(marker => {
          latlngbounds.extend(marker.position);
        });
      }
      if (this.getPointsAddress.length) {
        this.getPointsAddress.forEach(marker => {
          latlngbounds.extend(marker.coordonnees);
        });
      }
      latlngbounds.extend(this.centerReseaux);
      this.$refs.map.fitBounds(latlngbounds);
    },
    async initPoi() {
      const map = await this.$refs.map.$mapPromise;
      const styleMap = new google.maps.StyledMapType(
        STYLE_MAPS_POI_HIDDEN,
        { name: MAP_TYPE_NAME },
      );
      map.mapTypes.set('styled_map', styleMap);
    },
  },
  async mounted() {
    await this.autoZoom();
    await this.initPoi();
    if (this.hasGeoMarketing) {
      await this.updateLayer();
      await this.actionsLoadSymboles();
    }
    if (this.getZoomCartoReseaux >= 12) {
      this.setZoomCartoReseaux(11);
    }
  },
  components: {
    appInfoWindowMapFaces: InfoWindowMapFaces,
    appInfoWindowMapReseaux: InfoWindowMapReseaux,
    appStatistiquesGeoMarketing: statistiquesGeoMarketing,
  },
};

</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxNumerique/recherche/carte.vue